// src/utils/formatRarity.js
const RARITY_TRANSLATION = {
  common: "Standard",
  uncommon: "Refined",
  rare: "Experimental",
  epic: "Prototype",
  legendary: "Unique"
};

export const formatRarityName = (dbRarity) => {
  if (!dbRarity) return "Standard";
  return RARITY_TRANSLATION[dbRarity.toLowerCase()] || dbRarity;
};